export { default as uniq } from 'lodash/uniq'
export { default as slice } from 'lodash/slice'
export { default as isString } from 'lodash/isString'
export { default as isFunction } from 'lodash/isFunction'
export { default as isArray } from 'lodash/isArray'
export { default as isNumber } from 'lodash/isNumber'
export { default as isObject } from 'lodash/isObject'
export { default as uniqueId } from 'lodash/uniqueId'

export * from './env'
export * from './nil'
export * from './extend-constructor'
export * from './copy-defined-props'
export { default as shallowCompare } from './shallow-compare'
export { default as frozen } from './frozen'
export { default as invariant } from './invariant'
export { default as fuze } from './fuze'
export { default as forEach } from 'lodash/forEach'
export { default as isEmpty } from 'lodash/isEmpty'
export { default as flatten } from 'lodash/flatten'
export { default as castArray } from 'lodash/castArray'
export { default as env } from './current-env'

export function extendPropertiesOf(target, obj) {
  return Object.defineProperties(target, Object.getOwnPropertyDescriptors(obj))
}

export function ucfirst(string) {
  return string[0].toUpperCase() + string.slice(1)
}

export function lcfirst(string) {
  return string[0].toLowerCase() + string.slice(1)
}

export function setCookie(name, val, days) {
  const d = new Date()
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = name + '=' + val + ';' + expires + ';path=/'
}

export function getCookie(name) {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}

export function getQueryVariable(key) {
  const query = window.location.search.substring(1)
  const vars = query.split('&')

  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=')
    if (pair[0] == key) return pair[1]
  }

  return false
}

export function getQueryVariables(keys) {
  const vals = {}
  keys.forEach((key) => {
    const val = getQueryVariable(key)
    if (val) vals[key] = val
  })

  return vals
}

export function assertValue(obj, key) {
  const val = obj[key]

  if (!val) {
    throw `missing '${key}' value`
  }

  return val
}

export function extractValue(obj, key, assert = true) {
  var val = assert ? assertValue(obj, key) : obj[key]

  delete obj[key]

  return val
}

export function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  )
}

// thanks mozilla https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement
export const loadScript = ((oHead) => {
  function loadError(oError) {
    throw new URIError(
      'The script ' + oError.target.src + ' is not accessible.'
    )
  }

  return function loadScript(sSrc, fOnload) {
    var oScript = document.createElement('script')
    oScript.type = 'text/javascript'
    oScript.onerror = loadError
    if (fOnload) {
      oScript.onload = fOnload
    }
    oHead.appendChild(oScript)
    oScript.src = sSrc
  }
})(document.head || document.getElementsByTagName('head')[0])
